//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'Possum',
  data () {
    return {
      defaultJson: {
        'Mod. COPD': '中度 COPD',
        'Rest dyspnea': '休息时',
        'Fibrosis': '纤维化',
        'Physiologic Score %@': '生理学评分：%@',
        'Q Waves or ST-T changes': 'Q 波或 ST-T 改变',
        'White Blood Cell Count': '白细胞计数',
        'Physiologic Variables': '生理学因素',
        'EKG': 'ECG',
        'Glasgow Coma Scale': 'Glasgow 昏迷评分',
        'Edema': '水肿',
        'Heart Rate': '心率',
        'Peripheral edema, warfarin': '外周水肿、华法林',
        'Drugs': '药物',
        'Local pus': '局部积脓',
        'Respiratory': '呼吸',
        'Q or ST': 'Q 或 ST',
        'ø dypnea': '无呼吸困难',
        '≥3': '≥ 3',
        'Cardiomegaly +': '心脏增大 +',
        'Operative Variables': '手术因素',
        'Systolic BP': '收缩压',
        'GCS': 'GCS',
        'Distant Mx': '远处转移',
        'Nodal metastases': '淋巴结转移',
        'None': '无',
        'Primary only': '仅原发灶',
        'No failure': '无心力衰竭',
        'Number of procedures': '手术次数',
        'POSSUM': 'POSSUM',
        'Exertion dysp.': '运动时',
        'Serum Na': '血清 Na',
        'Severe': '严重',
        'Major +': '大型 +',
        'Mild COPD on CXR': '胸片提示轻度 COPD',
        'Operative Score %@': '手术评分：%@',
        'Primary': '原发灶',
        'Elective': '择期',
        'Distant metastases': '远处转移',
        'Other abnormality': '其他异常',
        '≥5 ectopics': '早搏 ≥ 5',
        'Cardiac': '心脏',
        'Cardiomegaly': '心脏增大',
        'WBC': 'WBC',
        'Any other abnormal rythm': '任何其他类型的心律失常',
        'AF and pulse 60-90': 'AF 且脉率 60 - 90',
        'Age': '年龄',
        'Emergency (immediate surgery)': '急诊（立即手术）',
        'P-POSSUM': 'P-POSSUM',
        'Local': '局部',
        'Predicted Death Rate': '预测死亡率',
        'Total Blood Loss': '总失血量',
        'Moderate COPD on CXR': '胸片提示中度 COPD',
        'Complex major': '大型复杂性',
        'Normal': '正常',
        'No dyspnea': '无呼吸困难',
        'Emergency (surgery 2-24h after admission)': '急诊（收治后 2 - 24 h 手术）',
        'Emergency ++': '急诊 ++',
        'Limiting dysp.': '限制性',
        'Raised JVP': '颈静脉压力升高',
        'Nodal Mx': '淋巴结转移',
        'Dyspnoea on exertion': '运动时呼吸困难',
        'Mild COPD': '轻度 COPD',
        'BUN': 'BUN',
        'Cardiomegaly ++': '心脏增大 ++',
        'Operative Severity': '手术严重性',
        'Serum K': '血清 K',
        'Urea': '尿素',
        'Antianginal, antihypertensive': '抗心绞痛药、降压药',
        'Systolic Blood Pressure': '收缩压',
        'Dyspnea on rest': '休息时',
        'Free bowel with pus or blood': '游离肠内容物伴脓或血',
        'Major': '大型',
        '5 or more EVS/min': '早搏 ≥ 5 个/分',
        'Moderate': '中型',
        'Fibrosis or consolidation': '纤维化或实变',
        'Borderline cardiomegaly': '临界性心脏增大',
        'Hemoglobin': '血红蛋白',
        'Minor (serous fluid)': '轻微（浆液）',
        'Emergency': '急诊',
        'AF 60-90': 'AF 60 - 90',
        'Diuretics, digoxin': '利尿药、地高辛',
        'Mode of surgery': '手术分类',
        'Cancer': '恶性肿瘤',
        'Peritoneal soiling': '腹腔污染',
        'Minor': '轻微',
        'Limiting dyspnea (1 flight)': '限制性呼吸困难（飞行中）'
      },
      form: {
        age: '',
        hr: '',
        sys: '',
        cardiac: '',
        ekg: '',
        resp: '',
        gcs: '',
        hb: '',
        wbc: '',
        na: '',
        k: '',
        urea_bun: '',
        urea_urea: '',

        sx: '',
        opsev: '',
        cancer: '',
        mulproc: '',
        peritoneal: '',
        bloodloss: ''
      },
      pt: 'urea_bun',
      hasScore: false,
      disabled: false,
      dataList: [
        {value: 'urea_bun', name: 'BUN'},
        {value: 'urea_urea', name: '尿素'}
      ],
      dataList1: [
        {value: '1', name: '无心力衰竭', shortName: '无心力衰竭'},
        {value: '2', name: '利尿药、地高辛', shortName: '药物'},
        {value: '2', name: '抗心绞痛药、降压药', shortName: '药物'},
        {value: '4', name: '外周水肿、华法林', shortName: '水肿'},
        {value: '4', name: '临界性心脏增大', shortName: '心脏增大 +'},
        {value: '8', name: '颈静脉压力升高', shortName: '颈静脉压力升高'},
        {value: '8', name: '心脏增大', shortName: '心脏增大 ++'}
      ],
      dataList2: [
        {value: '1', name: '正常', shortName: '正常'},
        {value: '4', name: 'AF 且脉率 60 - 90', shortName: 'AF 60 - 90'},
        {value: '8', name: '任何其他类型的心律失常', shortName: '其他异常'},
        {value: '8', name: '早搏 ≥ 5 个/分', shortName: '早搏 ≥ 5'},
        {value: '8', name: 'Q 波或 ST-T 改变', shortName: 'Q 或 ST'}
      ],
      dataList3: [
        {value: '1', name: '无呼吸困难', shortName: '无呼吸困难'},
        {value: '2', name: '运动时呼吸困难', shortName: '运动时'},
        {value: '2', name: '胸片提示轻度 COPD', shortName: '轻度 COPD'},
        {value: '4', name: '限制性呼吸困难（飞行中）', shortName: '限制性'},
        {value: '4', name: '胸片提示中度 COPD', shortName: '中度 COPD'},
        {value: '8', name: '休息时', shortName: '休息时'},
        {value: '8', name: '纤维化或实变', shortName: '纤维化'}
      ],
      dataList4: [
        {value: '1', name: '择期', shortName: '择期'},
        {value: '4', name: '急诊（收治后 2 - 24 h 手术）', shortName: '急诊'},
        {value: '8', name: '急诊（立即手术）', shortName: '急诊 ++'}
      ],
      dataList5: [
        {value: '1', name: '轻微', shortName: '轻微'},
        {value: '2', name: '中型', shortName: '中型'},
        {value: '4', name: '大型', shortName: '大型'},
        {value: '8', name: '大型复杂性', shortName: '大型复杂性'}
      ],
      dataList6: [
        {value: '1', name: '无', shortName: '无'},
        {value: '2', name: '仅原发灶', shortName: '原发灶'},
        {value: '4', name: '淋巴结转移', shortName: '淋巴结转移'},
        {value: '8', name: '远处转移', shortName: '远处转移'}
      ],
      dataList7: [
        {value: '1', name: '1', shortName: '1'},
        {value: '4', name: '2', shortName: '2'},
        {value: '8', name: '≥3', shortName: '≥3'}
      ],
      dataList8: [
        {value: '1', name: '无', shortName: '无'},
        {value: '2', name: '轻微（浆液）', shortName: '轻微'},
        {value: '4', name: '局部积脓', shortName: '局部'},
        {value: '8', name: '游离肠内容物伴脓或血', shortName: '严重'}
      ],
      logit: '...'
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      console.log(this.form)
      var self = this
      let form = JSON.parse(JSON.stringify(self.form))
      for (const key in form) {
        // if (form.hasOwnProperty(key)) {
        //   if (!form[key]) {
        //     flag = false
        //   } else {
        //     if (form[key] == '---') {
        //       flag = false
        //     } else {
        form[key] = Number(form[key])
        //     }
        //   }
        // }
      }
      var ureavalue = (this.pt === 'urea_bun') ? form.urea_bun * 0.3571 : form.urea_urea
      console.log(1111111, ureavalue)
      var a = (form.age <= 60 ? 1 : (form.age <= 70 ? 2 : 4))
      var b = (form.hr <= 39 ? 8 : (form.hr < 50 ? 2 : (form.hr <= 80 ? 1 : (form.hr <= 100 ? 2 : form.hr <= 120 ? 4 : 8))))
      var c = (form.sys <= 89 ? 8 : (form.sys <= 99 ? 4 : (form.sys <= 109 ? 2 : (form.sys <= 130 ? 1 : (form.sys <= 170 ? 2 : 4)))))
      var d = (form.gcs <= 8 ? 8 : (form.gcs <= 11 ? 4 : (form.gcs <= 14 ? 2 : 1)))
      var e = (form.hb < 100 ? 8 : (form.hb < 115 ? 4 : (form.hb < 130 ? 2 : (form.hb <= 160 ? 1 : (form.hb < 170 ? 2 : (form.hb < 180 ? 4 : 8))))))
      var f = (form.wbc <= 3 ? 4 : (form.wbc < 4 ? 2 : (form.wbc <= 10 ? 1 : (form.wbc <= 20 ? 2 : 4))))
      var g = (form.na <= 125 ? 8 : (form.na <= 130 ? 4 : (form.na <= 135 ? 2 : 1)))
      var h = (form.k <= 2.8 ? 8 : (form.k <= 3.1 ? 4 : (form.k <= 3.4 ? 2 : (form.k <= 5 ? 1 : (form.k <= 5.3 ? 2 : (form.k <= 5.9 ? 4 : 8))))))
      var i = (ureavalue <= 7.5 ? 1 : (ureavalue <= 10 ? 2 : (ureavalue <= 15 ? 4 : 8)))
      console.log(a, b, c, d, e, f, g, h)
      var score = (form.age &&
                    form.hr &&
                    form.sys &&
                    form.gcs &&
                    form.hb &&
                    form.wbc &&
                    form.na &&
                    form.cardiac &&
                    form.ekg &&
                    form.resp &&
                    form.k) ? a +
                    b +
                    c +
                    form.cardiac +
                    form.ekg +
                    form.resp +
                    d +
                    e +
                    f +
                    g +
                    h +
                    i : null

      var score1 = form.opsev + form.mulproc + form.peritoneal + form.cancer + form.sx +
                    (form.bloodloss <= 100 ? 1 : (form.bloodloss <= 500 ? 2 : (form.bloodloss < 1000 ? 4 : 8)))

      const physscore = score
      const opscore = score1
      const R = (0.13 * physscore) + (0.16 * opscore) - 7.04
      const score2 = 100 * (1 / (1 + Math.pow(Math.E, (-R))))
      const Rp = (0.1692 * physscore) + (0.1550 * opscore) - 9.065
      const score3 = 100 * (1 / (1 + Math.pow(Math.E, (-Rp))))
      console.log(
        score,
        score1,
        score2,
        score3)
      return {
        score,
        score1,
        score2,
        score3
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/formulas/Anae/Possum.vue